export function getOrigin(url) {
    var baseUrl = url.match(/(https?:\/\/.*?)(\/|$)/);
    return baseUrl ? baseUrl[1] : url;
}
export function addSearchParams(url, params) {
    if (params === void 0) { params = {}; }
    var enc = encodeURIComponent;
    var searchParams = Object.keys(params)
        .map(function (key) { return enc(key) + "=" + enc(params[key]); });
    if (!searchParams.length) {
        return url;
    }
    var separator = url.includes('?') ? '&' : '?';
    return "" + url + separator + searchParams.join('&');
}
